import React from 'react';
import { useSelector } from 'react-redux';
import { formatter, getResizedImageUrl } from '../helpers';
import { DEFAULT_IMAGE_WIDTH_MOBILE_TRAY } from '../constants';

const SwipeableTrayTrigger = () => {
	const { vehicleConfiguration } = useSelector((state) => state);
	const { year, make, model, trim, price, bodyStyle, image } =
		vehicleConfiguration;

	// TEMP UNTIL WE SOLVE MODEL DATA ISSUE
	const placeHolderImgUrl =
		'/static/v8/global/images/bodystyle/160x87/sedan_ext_225.png';

	return (
		<div className="pt-3 tray-trigger">
			<div className="tray-trigger-handle" />
			<div className="preview">
				<img
					style={{ maxWidth: `${DEFAULT_IMAGE_WIDTH_MOBILE_TRAY}px` }}
					className="align-left mx-3 mt-2"
					src={`${
						image
							? getResizedImageUrl(
									image,
									DEFAULT_IMAGE_WIDTH_MOBILE_TRAY
							  )
							: placeHolderImgUrl
					}`}
					alt={`${year} ${make} ${model} thumbnail`}
				/>
				<span className="font-weight-bold">
					{year} {make}
					<br />
					{model} {trim} {bodyStyle}
				</span>
				<span
					style={{ lineHeight: '0' }}
					className="mr-3 display-4 align-right"
				>
					{formatter.format(price)}
				</span>
			</div>
		</div>
	);
};

export default SwipeableTrayTrigger;
